const Joi = require('joi');
const Moment = require('moment/moment');

const FormConfig = module.exports = {
    formId: 'survey-edit-form',

    rerenderDeps(props = {}) {

        return [
            props.defaults,
            props.fields,
            props.formId,
            props.onSubmit,
            props.schema
        ];
    },

    buildFormConfig(props = {}) {

        const {
            defaults = FormConfig.defaults.build(),
            fields = FormConfig.fields.build(),
            formId = FormConfig.formId,
            onSubmit,
            schema = internals.schema
        } = props;

        return {
            onSubmit,
            defaults,
            fields,
            schema,
            formId,
            formOptions: {
                criteriaMode: 'all'
            },
            syncDefaults: false
        };
    },

    defaults: {
        build() {

            return internals.buildDefaults();
        }
    },

    fields: {
        build() {

            return internals.buildFields();
        }
    },

    submit: {
        buildPayload(data = {}) {

            return {
                id: data.id,
                title: data.title,
                description: data.description,
                startDate: Moment(data.startDate).format('YYYY-MM-DD'),
                endDate: Moment(data.endDate).format('YYYY-MM-DD'),
                notifyUsers: data.notifyUsers,
                manuallyStop: data.manuallyStop,
                startImmediately: data.startImmediately,
                questions: data.questions
            };
        }
    },

    schema: null
};

FormConfig.buildDefaults = FormConfig.defaults.build;
FormConfig.buildFields = FormConfig.fields.build;
FormConfig.buildSubmitPayload = FormConfig.submit.buildPayload;

const internals = {};

internals.buildDefaults = () => ({
    id: null,
    title: '',
    description: '',
    notifyUsers: true,
    manuallyStop: false,
    startDate: Moment().add(1, 'days').format('YYYY-MM-DD'),
    endDate: Moment().add(1, 'days').add(1, 'month').format('YYYY-MM-DD'),
    startImmediately: false,
    selectedRole: '',
    selectedUsers: [],
    questions: []
});

internals.buildFields = () => ([
    {
        name: 'id',
        type: 'TextField'
    },
    {
        name: 'title',
        type: 'TextField'
    },
    {
        name: 'description',
        type: 'TextareaField'
    },
    {
        name: 'notifyUsers',
        type: 'CheckboxField'
    },
    {
        name: 'manuallyStop',
        type: 'CheckboxField'
    },
    {
        name: 'startDate',
        type: 'DateField'
    },
    {
        name: 'endDate',
        type: 'DateField'
    },
    {
        name: 'startImmediately',
        type: 'CheckboxField'
    },
    {
        name: 'selectedRole',
        type: 'SelectField'
    },
    {
        name: 'selectedUsers',
        type: 'MultiSelectField'
    },
    {
        name: 'questions',
        type: 'custom'
    }
]);

internals.answerSchema = Joi.object({
    text: Joi.string().required().messages({
        'string.empty': 'Answer text is required',
        'any.required': 'Answer text is required'
    })
});

internals.schema = Joi.object({
    id: Joi.number().required(),

    title: Joi.string().required().messages({
        'string.empty': 'Survey title is required',
        'any.required': 'Survey title is required'
    }),

    description: Joi.string().allow(null, '').optional(),

    notifyUsers: Joi.boolean(),
    manuallyStop: Joi.boolean(),
    startImmediately: Joi.boolean(),

    startDate: Joi.date().empty('').required().messages({
        'date.base': 'The value must be a date (MM/DD/YYYY)',
        'any.required': 'Survey Start Date is required'
    }),

    endDate: Joi.when('manuallyStop', {
        is: false,
        then: Joi.date().empty('').required().messages({
            'date.base': 'The value must be a date (MM/DD/YYYY)',
            'any.required': 'Survey End Date is required'
        }),
        otherwise: Joi.any().optional()
    }),

    questions: Joi.array().items(
        Joi.object({
            text: Joi.string().required().messages({
                'string.empty': 'Question text is required',
                'any.required': 'Question text is required'
            }),

            answerType: Joi.string().valid('freeInput', 'select', 'checkbox'),

            answers: Joi.array().items(internals.answerSchema).when('answerType', {
                is: Joi.valid('select', 'checkbox'),
                then: Joi.array().items(internals.answerSchema).min(1).required().messages({
                    'array.min': 'At least one answer is required',
                    'any.required': 'At least one answer is required'
                }),
                otherwise: Joi.array().items(internals.answerSchema).optional()
            })
        })
    ).min(1).required().messages({
        'array.min': 'You need at least one question',
        'any.required': 'At least one question is required'
    })
});

FormConfig.schema = internals.schema;
FormConfig.internals = internals;
